export default {
    namespaced: true,
    state: () => ({
        search: '',
        status: 'All',
        year: "-1",
        extendedFilter: {
            RegDateFrom: {
                label: "Дата_регистрации_c",
                value: null
            },
            RegDateTo: {
                label: "Дата_регистрации_по",
                value: null
            },
            Language: {
                label: "Язык_документа",
                value: null
            },
            ProtocolType: {
                label: "Категория_поручения",
                value: null
            },
            ProtocolStatus: {
                label: "Статус",
                value: null
            },
            ControlDateFrom: {
                label: "Контрольный_срок_с",
                value: null
            },
            ControlDateTo: {
                label: "Контрольный_срок_по",
                value: null
            },
            ProtocolResolutionExecuter: {
                label: "Ответственный_исполнитель",
                value: []
            },
        },
        tableOptions:
        {
            page: 1,
            itemsPerPage : 15,
            sortBy : [ "regdate" ],
            sortDesc : [ true ],
            groupBy : [],
            groupDesc : [],
            multiSort : false,
            mustSort : false
        },
    }),
    mutations: {
        SET_SEARCH (state, payload){
            state.search = payload;
        },
        SET_STATUS (state, payload){
            state.status = payload;
        },
        SET_YEAR (state, payload){
            state.year = payload;
        },
        SET_TABLE_OPTION (state, payload) {
            state.tableOptions = payload;
        },
        SET_TABLE_OPTION_PAGE (state, payload) {
            state.tableOptions.page = payload;
        },
        SET_EXTENDED_FILTER (state, payload) {
            state.extendedFilter = payload;
        }
    },
    getters: {
        getSearch: (state) => state.search,
        getStatus: (state) => state.status,
        getYear: (state) => state.year,
        getExtendedFilter: (state) => state.extendedFilter,
        getTableOptions: (state) => state.tableOptions,
    }
}